import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
// material
import { green, red, teal } from '@mui/material/colors';
import { Card, Grid, Container, Typography, Box, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { FormatColorReset } from '@mui/icons-material';
import { deleteSubcription, getSubcriptions, updateSubcription } from '../../Redux-Store/actions/subscriptionAction';
import Page from '../../components/Page';
import CommonDeleteModel from '../../Component/CommonDeleteModel';
import ActiveDeactiveModel from '../../Component/ActiveDeactiveModel';
import DataGridHeader from '../../Component/DataGridComponents/DataGridHeader';
import ActionColumn from '../../Component/TableComponent/ActionColumn';
import PagesTopBar from '../../Component/PagesTopBar';
import SwitchBtn from '../../Component/DataGridComponents/SwitchBtn';
import StatusColumn from '../../Component/DataGridComponents/StatusColumn';
import CommonDeleteBox from '../../Component/ModelBox/CommonDeleteBox';
import ShowMessage from '../../Component/ShowMessage';

// ----------------------------------------------------------------------
function CustomToolbar(props) {
  const [search, setSearch] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onChange = (e) => {
    console.log('column search', e.target.value);
    // Update the state if you want instant updates
    setSearch(e.target.value);
  };

  const onKeyDown = (e) => {
    // console.log("dwn");
    if (e.key === 'Enter') {
      setSearch(e.target.value);
    }
  };
  const handleColumnSelection = (e, value) => {
    console.log('selection ', value);
  };
  return (
    <DataGridHeader
      showSearch
      showBulkAction={false}
      showDropdown={false}
      showExport
      defaultPropsCols=""
      onAutocompleteChange=""
      quickFilterProps=""
      handleClick={handleClick}
      handleCloseMenu={handleCloseMenu}
      openMenu={openMenu}
      anchorEl={anchorEl}
      onchange={onChange}
      onkeydown={onKeyDown}
      searchValue={search}
      handleColumnSelection={handleColumnSelection}
    />
  );
}

// ----------------------------------------------------------------------

export default function Subscription() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { subscriptions, isloading } = useSelector((state) => ({
    subscriptions: state.subscription?.subcription?.data,
    isloading: state.subscription?.isLoading,
  }));

  console.log('subscriptions', isloading);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState('');
  const [filterData, setFilterData] = useState(null);
  const [subscriptionDelete, setSubscriptionDelete] = useState();
  const [open, setOpen] = useState(false);
  const [openActiveDeactive, setOpenActiveDeactive] = useState(false);
  const [activeDeactivateObject, setActivateDeactivateObject] = useState({});
  const [isDeleteDialogShow, setIsDeleteDialogShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isErrorShow, setIsErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0 });
  const [submitLoader, setSubmitLoader] = useState(false);
  const [serialNumber, setSerialNumber] = useState(0);

  const getPeginationModelValue = (e) => {
    console.log('getPeginationModelValue', e);
    setSerialNumber(e.page * e.pageSize);
    setPaginationModel(e);
    setPage(e.page);
  };

  const paramsData = {
    filterData,
    page,
    rowsPerPage,
  };

  useEffect(() => {
    dispatch(getSubcriptions(paramsData));
  }, [page, filterData]);

  const handleActivate = (uuid, slug, isactive) => {
    console.log('handleActive', uuid, slug, isactive);

    let params;
    if (slug === 1) {
      params = {
        uuid: uuid.toString(),
        isactive,
        status: isactive ? 'Active' : 'Inactive',
      };
    } else {
      params = {
        uuid: uuid.toString(),
        isactive,
        status: isactive ? 'Active' : 'Inactive',
      };
    }
    console.log('params in update', params);
    dispatch(updateSubcription(params));
    setOpenActiveDeactive(false);
    setActivateDeactivateObject({});
  };

  const handleDelete = (e) => {
    setSubscriptionDelete(e.uuid);
    setOpen(!open);
    // setTimeout(() => {
    //   setOpen(false);
    // }, 1500);
  };
  const handleDeleteCancle = () => {
    setOpen(!open);
  };

  const handleSubmit = () => {
    dispatch(deleteSubcription({ uuid: subscriptionDelete }))
      .unwrap()
      .then((response) => {
        setSubmitLoader(true);
        console.log('response in delete subscription Delete', response);
        if (response.status === 200) {
          setSubmitLoader(false);
          setIsShow(true);
          setOpen(!open);
          console.log('response', response);
          setErrorMessage(response.data.message);
          dispatch(getSubcriptions(paramsData));
        }
        setTimeout(() => {
          setIsShow(false);
          // navigate(-1);
        }, 1500);
      })
      .catch((error) => {
        setOpen(!open);
        setSubmitLoader(false);
        setIsErrorShow(true);
        console.log('error');
      });
  };

  const handleActiveDeactiveClick = (object) => {
    console.log('object', object);
    setActivateDeactivateObject(object);
    setOpenActiveDeactive(!openActiveDeactive);
  };

  const handleActiveDeactiveSubmit = () => {
    console.log('activeDeactivateObject', activeDeactivateObject);
    handleActivate(activeDeactivateObject?.uuid, activeDeactivateObject?.isactive, activeDeactivateObject?.status);
  };

  const handleEdit = (rowData) => {
    navigate('/dashboard/create_subscription', {
      state: {
        subscriptionData: rowData,
      },
    });
  };

  const handleSearch = (value) => {
    console.log('search', value);
    setFilterData(value);
    setSearchValue(value);
  };
  const CustomNoRowsOverlay = () => {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        {/* Your custom message here */}
        <h4>No Data Found</h4>
      </div>
    );
  };

  const columns = [
    {
      field: 'id',
      headerName: 'Sr no',
      width: 80,
      // flex: 0.4,
      renderCell: (params) => serialNumber + params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    { field: `plan_title`, headerName: 'Plan Name', width: 200, type: 'string' },
    {
      field: `plan_price`,
      headerName: 'Price',
      width: 150,
      type: 'string',
      // flex: 1,
      renderCell: (params) => (
        <Typography fontSize={'14px'} fontWeight={'600'} color={'green'}>
          &#8377; {params?.row?.plan_price}
        </Typography>
      ),
    },
    { field: 'plan_description', headerName: ' Description', width: 300, type: 'string' },
    {
      field: 'status',
      headerName: 'Status',
      // flex: 0.8,
      renderCell: (params) => <StatusColumn params={params.row} />,
    },
    {
      field: 'no_of_locations',
      headerName: 'No. of location',
      width: 150,
      // flex: 1,
      renderCell: (params) =>
        params?.row?.subscription_type === 'vendor_recruitment_subscription' ? (
          <Box m={'10px'}>
            <Typography
              sx={{
                padding: '2px 12px',
                borderRadius: '6px',
                background: '#d5efdf',
                border: '1px solid green',
                color: 'green',
                mt: '10px',
                mb: '10px',
                fontSize: '15px',
                fontWeight: 500,
              }}
            >
              {params?.row?.no_of_locations}
            </Typography>
          </Box>
        ) : (
          <Box m={'10px'}>
            <Typography>---</Typography>
          </Box>
        ),
    },
    {
      field: 'subscription_type',
      headerName: 'Subscription Type',
      width: 300,
      // flex: 1,
      renderCell: (params) =>
        params?.row?.subscription_type === 'vendor_recruitment_subscription' ? (
          <Chip
            label="Vendor Recruitment Subscription"
            style={{
              background: teal[800],
              color: 'white',
              fontSize: '12px',
              marginLeft: '10px',
              borderRadius: '6px',
              fontWeight: '600',
            }}
          />
        ) : (
          <Chip
            label="Consumer Matrimony Subscription"
            style={{
              background: red[600],
              color: 'white',
              fontSize: '12px',
              marginLeft: '10px',
              borderRadius: '6px',
              fontWeight: '600',
            }}
          />
        ),
    },

    {
      field: `createdAt`,
      headerName: 'Created On',
      width: 200,
      type: 'string',

      renderCell: (params) => {
        return moment(params?.row?.createdAt).format('DD/MM/YYYY hh:MM A');
      },
    },

    {
      field: 'col6',
      headerName: 'Actions',
      width: 250,
      renderCell: (params) => (
        <ActionColumn
          showView={false}
          showEdit
          showDelete
          // handleView={() => handleView(params.row)}
          handleEdit={() => handleEdit(params.row)}
          handleDelete={() => handleDelete(params.row)}
        />
      ),
    },
  ];
  const rows = [];

  return (
    <>
      <Page title="User" sx={{ width: '100%' }}>
        {openActiveDeactive ? (
          <ActiveDeactiveModel
            isOpen={openActiveDeactive}
            handleClose={handleActiveDeactiveClick}
            handleSubmit={handleActiveDeactiveSubmit}
            handleCancel={handleActiveDeactiveClick}
            activeDeactivateObject={activeDeactivateObject}
          />
        ) : null}
        {open ? (
          <CommonDeleteBox
            openDialog={open}
            handleDeleteYes={handleSubmit}
            handleClose={handleDeleteCancle}
            title="Subscription Plan"
            description="Are you sure you want to delete plan ?"
          />
        ) : null}

        <Container id="subscription" sx={{ width: '100%' }} maxWidth="xl">
          <PagesTopBar
            Add
            title="Subscriptions"
            subTitle="List of all Subscriptions in your app."
            btnText="Create Subscription"
            link="/dashboard/create_subscription"
            handleSearch={handleSearch}
            clearInput={() => {
              handleSearch('');
            }}
          />

          <Card>
            <Grid container>
              <Grid item lg={12} xs={12} sm={12}>
                <DataGrid
                  disableColumnMenu
                  style={{
                    height: 520,
                    width: '100%',
                    borderRadius: '10px',
                    fontSize: '14px',
                  }}
                  sx={{}}
                  paginationModel={paginationModel}
                  onPaginationModelChange={getPeginationModelValue}
                  pageSizeOptions={[10, 20, 30]}
                  paginationMode="server"
                  loading={isloading}
                  rows={subscriptions?.data ? subscriptions?.data : rows}
                  columns={columns}
                  getRowId={(row) => row.id}
                  localeText={{ noRowsLabel: <CustomNoRowsOverlay /> }}
                  slots={
                    {
                      // toolbar: CustomToolbar,
                    }
                  }
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: {
                        variant: 'outlined',
                        size: 'small',
                        sx: {
                          bgcolor: '#ffffff',
                          // borderRadius: '8px',
                          // border: '1px solid rgba(0,0,0,0.1)',
                          pb: '0px',
                          '& fieldset': { border: 'none' },
                        },
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Card>
        </Container>
        {/* ----------------------Message box-------------------- */}
        <ShowMessage onClose={() => setIsShow(false)} title={errorMessage} type="success" open={isShow} />

        <ShowMessage
          onClose={() => setIsErrorShow(false)}
          title={"Subscription plan is assigned to active vendor's cannot be deleted"}
          type="error"
          open={isErrorShow}
        />
      </Page>
    </>
  );
}
